import {
  trigger,
  animate,
  transition,
  style,
} from '@angular/animations';

import { ANIMATION } from './animation.constants';

const duration = ANIMATION.duration;

export const leaveAnimation = trigger('leaveAnimation', [
  transition(':leave', [
    animate( duration + ' ease-in-out', style({}))
  ])
]);